// extracted by mini-css-extract-plugin
module.exports = {"root":"IconLink_root__3UTbn","light":"IconLink_light__3Q9Lf","dark":"IconLink_dark__17RTD","circle":"IconLink_circle__39OnT"};